import React from "react";

function AccountGuard({ children }) {
  return <React.Fragment>{children}</React.Fragment>;
}

export default AccountGuard;
